// Logout.js
import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase-config";
import { LogoutOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import "./Logout.scss";
const Logout = () => {
  const logout = async () => {
    await signOut(auth);
    localStorage.removeItem("token");
  };

  return (
    <div onClick={logout} className="frame_logout_icon">
      {" "}
      <Tooltip title="Logout Here" color="#7679de">
        <LogoutOutlined className="icon_logout" style={{ fontSize: "25px" }} />
      </Tooltip>
    </div>
  );
};

export default Logout;
